module.exports = __webpack_public_path__ + "static/media/warrantyActive.5d109d68.svg";